import React, { useEffect } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { useAisleBay } from '@thd-nucleus/data-sources';
import { getStoreLayoutLink, ready } from '../helper';
import './aisle-bay-find-most.scss';

export const AisleBayFindMost = ({ itemId, products, store }) => {
  const { storeId, storeName } = store;
  const storeSkuIds = products.map((product) => product.identifiers?.storeSkuNumber);
  const [makeRequest, aisleBayResponse] = useAisleBay({
    storeId,
    storeSkuIds,
    lazy: true
  });

  useEffect(() => {
    ready('aisle-bay-find-most');
  });

  useEffect(() => {
    if (products.length && store?.storeId && !aisleBayResponse.called) {
      makeRequest();
    }
  }, [products, store]);
  const { aislebay } = aisleBayResponse.data || {};
  const { storeSkus } = aislebay || {};

  if (!((products || []).length && (storeSkus || []).length)) {
    return null;
  }

  const counts = {};
  let mostCommonAisle = { count: 0 };
  storeSkus.forEach((sku) => {
    const { aisleBayInfo } = sku;
    const { aisle, bay } = aisleBayInfo || {};
    if (!(aisle && bay)) {
      return;
    }
    counts[aisle] = counts[aisle] ? counts[aisle] + 1 : 1;
    mostCommonAisle = counts[aisle] > mostCommonAisle.count
      ? { ...aisleBayInfo, count: counts[aisle] }
      : mostCommonAisle;
  });

  return (
    <a className="aisle-bay-find-most" href={getStoreLayoutLink({ aislebay: mostCommonAisle, itemId, store })}>
      <Image asset="poi-outline.svg" alt="Location Pin" />
      <div className="aisle-bay-find-most__text">
        <span>Find most of these in&nbsp;
          <span className="aisle-bay-find-most__text--bold">Aisle {mostCommonAisle.aisle} at { storeName } Store</span>
        </span>
        <span className="aisle-bay-find-most__text--primary">Tap to see on store map</span>
      </div>
      <Image asset="next-arrow-orange.svg" alt="Arrow Right" />
    </a>
  );

};

AisleBayFindMost.displayName = 'AisleBayFindMost';

AisleBayFindMost.propTypes = {
  itemId: string,
  products: arrayOf(shape({})).isRequired,
  store: shape({
    storeId: string,
    storeName: string
  }).isRequired
};

AisleBayFindMost.defaultProps = {
  itemId: null
};
